module.exports = __webpack_public_path__ + "static/what-is-so-good-about-it-img-fbe926580afb36e2b253aafb32ac3f07.png";